// extracted by mini-css-extract-plugin
export default {"mainContainer":"onBoardFinalStep_mainContainer__TilqZ"};